export default "__VITE_ASSET__cc413582__"